const customTheme = {
  tokens: {
    colorBackgroundLayoutMain: {
      dark: "#101012",
      light: "#F7F6FB",
    },
    colorBackgroundContainerContent: {
      dark: "#1B1B22",
      light: "#FFFFFF",
    },
    colorBackgroundPopover: {
      dark: "#1B1B22",
      light: "#FFFFFF",
    },
    colorBackgroundContainerHeader: {
      dark: "#20202A",
      light: "#FBFAFF",
    },
    colorBackgroundNotificationSeverityHigh: {
      dark: "#ce3311",
    },
    colorBackgroundNotificationSeverityMedium: {
      dark: "#cc5f21",
    },
    colorBackgroundNotificationSeverityCritical: {
      dark: "#870303",
    },
    colorTextNotificationSeverityCritical: {
      dark: "#f9f9fa",
    },
    colorTextNotificationSeverityHigh: {
      dark: "#f9f9fa",
    },
    colorBackgroundControlDefault: {
      dark: "#20202A",
    },
    colorBackgroundInputDefault: {
      dark: "#222225",
    },
    colorBackgroundHomeHeader: {
      dark: "#101012",
    },
    colorTextLinkDefault: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorTextLinkHover: {
      light: "#6d28d9",
      dark: "#c4b5fd",
    },
    colorTextDropdownItemHighlighted: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorBackgroundButtonLinkHover: {
      light: "#f5f3ff",
      dark: "#2e1065",
    },
    colorTextButtonNormalDefault: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorTextButtonNormalHover: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorTextInteractiveHover: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorTextInteractiveActive: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorTextAccent: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorTextInteractiveDefault: {
      light: "#6c687d",
      dark: "#a6a0b7",
    },
    colorTextButtonNormalActive: {
      light: "#18181B",
      dark: "#FAFAF9",
    },
    colorBackgroundButtonLinkActive: {
      light: "#ede9fe",
      dark: "#2e1065",
    },
    borderRadiusButton: "8px",
    borderRadiusInput: "8px",
    borderRadiusContainer: "8px",
    colorForegroundControlDefault: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorForegroundControlDisabled: {
      dark: "#18181B",
      light: "#FAFAF9",
    },
    colorBackgroundDropdownItemHover: {
      light: "#F5F3FF",
      dark: "#25124d",
    },
    colorBackgroundDropdownItemDefault: {
      dark: "#1B1B22",
      light: "#FFFFFF",
    },
    colorTextDropdownItemDefault: {
      light: "#101828",
      dark: "#FFFFFF",
    },
    colorBackgroundButtonNormalHover: {
      light: "#F5F3FF",
      dark: "#25124d",
    },
    colorBackgroundButtonNormalActive: {
      light: "#EDE9FE",
      dark: "#2e1065",
    },
    colorBackgroundButtonNormalDefault: {
      light: "#FFFFFF",
      dark: "#1B1B22",
    },
    colorTextButtonPrimaryDefault: {
      light: "#FFFFFF",
      dark: "#FFFFFF",
    },
    colorTextButtonPrimaryHover: {
      light: "#FFFFFF",
      dark: "#FFFFFF",
    },
    colorTextButtonPrimaryActive: {
      light: "#F5F5F5",
      dark: "#E0E0E0",
    },
    colorBackgroundButtonPrimaryActive: {
      light: "#6d28d9",
      dark: "#7c3aed",
    },
    colorBackgroundButtonPrimaryDefault: {
      light: "#7c3aed",
      dark: "#8b5cf6",
    },
    colorBackgroundButtonPrimaryHover: {
      light: "#6d28d9",
      dark: "#7c3aed",
    },
    colorBackgroundInputDisabled: {
      light: "#FBFAFF",
      dark: "#20202A",
    },
    colorBackgroundButtonNormalDisabled: {
      dark: "#20202A",
      light: "#EFEDF7",
    },
    colorBorderButtonNormalDisabled: {
      dark: "#30303C",
      light: "#E5E1EE",
    },
    colorBackgroundButtonPrimaryDisabled: {
      light: "#DDD6FE",
      dark: "#3b2d6b",
    },
    colorBorderButtonNormalHover: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorBorderButtonNormalActive: {
      light: "#7c3aed",
      dark: "#a78bfa",
    },
    colorBorderButtonNormalDefault: {
      light: "#cfc8df",
      dark: "#454056",
    },
    colorBackgroundSegmentActive: {
      light: "#7c3aed",
      dark: "#8b5cf6",
    },
    colorBackgroundChatBubbleIncoming: {
      light: "#F5F3FF",
      dark: "#2A2A2C",
    },
    colorBorderFocused: {
      light: "#7c3aed",
      dark: "#8b5cf6",
    },
    colorBorderItemSelected: {
      light: "#7c3aed",
      dark: "#8b5cf6",
    },
    colorBackgroundItemSelected: {
      light: "#F5F3FF",
      dark: "#2e1065",
    },
  },
  contexts: {
    "top-navigation": {
      tokens: {
        colorBackgroundContainerContent: {
          light: "#f7f6fb",
          dark: "#080b11",
        },
        colorTextDropdownItemHighlighted: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorBorderDividerDefault: {
          light: "#e5e1ee",
          dark: "#1a2035",
        },
        colorTextButtonNormalDefault: {
          light: "#79716b",
          dark: "#949495",
        },
        colorBackgroundButtonLinkHover: {
          light: "#F5F3FF",
          dark: "#2e1065",
        },
        colorTextButtonNormalHover: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorTextInteractiveHover: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorTextInteractiveActive: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorTextAccent: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorTextInteractiveDefault: {
          light: "#79716b",
          dark: "#949495",
        },
        colorTextButtonNormalActive: {
          light: "#7c3aed",
          dark: "#a78bfa",
        },
        colorBackgroundButtonLinkActive: {
          light: "#ede9fe",
          dark: "#2e1065",
        },
        borderRadiusButton: "8px",
        colorBackgroundDropdownItemHover: {
          light: "#F5F3FF",
          dark: "#2e1065",
        },
        colorBackgroundDropdownItemDefault: {
          dark: "#18181B",
          light: "#FAFAF9",
        },
        colorTextDropdownItemDefault: {
          light: "#101828",
          dark: "#FFFFFF",
        },
        colorBorderDropdownItemFocused: {
          light: "#7c3aed",
          dark: "#8b5cf6",
        },
      },
    },
  },
};

export default customTheme;
